import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { color, shadows } = baseVariables;

export const StyledNavigationMenuWrapper = styled.div`
  width: 100%;
  position: relative;
  z-index: 11;
`;

export const StyledNavigationMenu = styled.div`
  display: block;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: ${color.base20};
  box-shadow: ${shadows.boxShadowSubsection};
  z-index: 2;
  position: relative;
`;

export const StyledActiveMenuContainer = styled.div`
  padding: ${toRem(16)} ${toRem(18)} ${toRem(16)};
  background: ${color.neutral40};
  font-size: ${toRem(23)};
  line-height: normal;
`;

export const StyledActiveMenu = styled.button`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  background: ${color.neutral40};
  color: ${color.base20};
  font-size: ${toRem(19)};
  cursor: pointer;
`;

export const StyledMainMenu = styled.nav`
  display: none;
  height: calc(100vh - ${toRem(54)});
  margin-top: ${toRem(7)};
  background: ${color.base20};
  position: relative;
  overflow: auto;
  &.open {
    display: block;
  }
`;

export const StyledMainMenuItems = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const StyledMainMenuItem = styled.li`
  padding: 0;
  border-bottom: ${toRem(1)} solid ${color.neutral40};
  color: inherit;
  list-style-type: none;
  a,
  button {
    display: block;
    padding: ${toRem(19)} ${toRem(24)} ${toRem(18)} ${toRem(16)};
    margin: 0;
    border-bottom: 0;
    font-size: ${toRem(16)};
    color: ${color.neutral00};
    background: transparent;
    .sub-menu-toggler {
      position: absolute;
      right: ${toRem(18)};
    }
  }
`;

export const StyledSubMenuWithBackCta = styled.div`
  display: none;
  background: ${color.base20};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  max-height: calc(100% - ${toRem(120)});
  overflow-y: auto;
  &.open {
    display: block;
  }
`;

export const StyledBackCtaContainer = styled.div`
  display: flex;
  height: ${toRem(57)};
  padding: 0 ${toRem(16)};
  background-color: ${color.neutral20};
  position: sticky;
  top: 0;
  align-items: center;
`;

export const StyledBackCta = styled.button`
  display: block;
  background: transparent;
  border: 0;
  cursor: pointer;
`;

export const StyledMainMenuTitle = styled.h1`
  display: block;
  padding-left: ${toRem(16)};
  padding-top: ${toRem(10)};
  margin: 0;
  margin-bottom: ${toRem(12)};
  font-size: ${toRem(22)};
`;

export const StyledSubMenuContainer = styled.div`
  overflow-y: auto;
`;

export const StyledSubMenu = styled.ul`
  list-style: none;
  padding-left: 0;
`;

export const StyledSubMenuItem = styled.li`
  a {
    color: ${color.neutral40};
  }

  &.selected {
    list-style-type: disc;
    padding-left: 0;
    margin-left: ${toRem(32)};
    &::marker {
      color: ${color.base10};
    }
    a {
      padding-left: 0;
      color: ${color.base10};
    }
  }
`;
